import React from 'react';
import { STATE_STYLES } from './constants';

export const AvailabilityLegend = ({ className = '' }) => (
  <div className={`flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-muted-foreground ${className}`} data-testid="availability-legend">
    {Object.entries(STATE_STYLES).map(([key, s]) => (
      <span key={key} className="flex items-center gap-1.5">
        <span className="inline-block w-3 h-3 rounded-sm border" style={{ background: s.bg, borderColor: s.border }} />
        {s.label}
      </span>
    ))}
  </div>
);
